import AdminLayout from "../../components/admin/layout/AdminLayout";
import DashboardPage from "../../components/admin/dashboard/Dashboard";

function Dashboard() {
  return (
    <AdminLayout>
      <DashboardPage />
    </AdminLayout>
  );
}

export default Dashboard;
